import { Alert, Button, Flex, Skeleton, Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import {
  AdminConsent,
  ThreatDetection,
  ThreatDetectionCredential
} from "./AppRegistrationSteps"

import type { ConnectedThreatDetectionProps } from "."

// Runtime protection's steps again, for an admin who finishes them after
// connecting: the credential and the consent, then the admin center
export const ConnectedThreatDetection = (
  props: ConnectedThreatDetectionProps
) => {
  const { connection, preInstall, isLoading, error, onRetry } = props
  const { t } = useTranslation("translation", {
    keyPrefix: "deployments.copilotStudio.threatDetectionSetup"
  })
  const { t: tRoot } = useTranslation()
  const azureTenantId = connection.azureTenantId || ""
  const appId = preInstall?.threatDetectionAppId

  return (
    <Flex vertical gap={16}>
      <Flex vertical gap={4}>
        <Text strong>{t("title")}</Text>
        <Text type="secondary">{t("intro")}</Text>
      </Flex>
      {preInstall ? (
        <>
          <ThreatDetectionCredential
            preInstall={preInstall}
            azureTenantId={azureTenantId}
          />
          {appId && (
            <AdminConsent appId={appId} azureTenantId={azureTenantId} />
          )}
          <ThreatDetection
            preInstall={preInstall}
            clientId={connection.clientId || ""}
          />
        </>
      ) : isLoading ? (
        <Skeleton active paragraph={{ rows: 3 }} />
      ) : (
        <Flex vertical gap={12} align="flex-start">
          {error && <Alert showIcon type="error" title={error} />}
          <Button onClick={onRetry}>{tRoot("general.refresh")}</Button>
        </Flex>
      )}
    </Flex>
  )
}
